// extracted by mini-css-extract-plugin
module.exports = {"self":"PageSectionGroup_self__bQn97"};